import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map, tap } from 'rxjs/operators';
import { RateCurve } from "src/app/models/rate-curve/rate-curve";
import { RateCurveProduct } from "src/app/models/rate-curve/rate-curve-product";
import { environment } from "src/environments/environment";

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json'
  })
};

@Injectable({
  providedIn: 'root'
})
export class RateCurveService {

  private apiUrl = environment.apiUrl;

  constructor(private httpClient: HttpClient) {
  }

  getRateCurvesByCountry(country: string): Observable<RateCurve[]> {
    return this.httpClient.get<RateCurve[]>(`${this.apiUrl}/api/v1/rate-curves/country/${country}`)
      .pipe(
        map((response: RateCurve[]) => {
          return response;
        })
      );
  }

  findRateCurveProductByProduct(productId: number): Observable<RateCurveProduct> {
    return this.httpClient.get<RateCurveProduct>(`${this.apiUrl}/api/v1/rate-curves/product/${productId}`)
      .pipe(
        map((response: RateCurveProduct) => {
          return response;
        })
      );
  }
  
}
